import {
  GET_LAW_CASES,
  GET_LAW_CASE,
  CREATE_LAW_CASE,
  UPDATE_LAW_CASE,
  DELETE_LAW_CASE,
  CLOSE_LAW_CASE,
  GET_CASE_DASHBOARD,
} from "../actions/lawCaseActions";

const initialState = {
  cases: [],
  case: null,
  dashboard: null,
  numberOfPages: 0,
  currentPage: 1,
  isLoading: false,
};

const lawCaseReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LAW_CASES:
      return {
        ...state,
        cases: action.payload.cases,
        numberOfPages: action.payload.totalPages,
        currentPage: action.payload.currentPage,
        isLoading: false,
      };

    case GET_LAW_CASE:
      return {
        ...state,
        case: action.payload,
        isLoading: false,
      };

    case CREATE_LAW_CASE:
      return {
        ...state,
        cases: [action.payload, ...state.cases],
        case: action.payload,
        isLoading: false,
      };

    case UPDATE_LAW_CASE:
    case CLOSE_LAW_CASE:
      return {
        ...state,
        cases: state.cases.map((c) =>
          c._id === action.payload._id ? action.payload : c,
        ),
        case: action.payload,
      };

    case DELETE_LAW_CASE:
      return {
        ...state,
        cases: state.cases.filter((c) => c._id !== action.payload),
      };

    case GET_CASE_DASHBOARD:
      return {
        ...state,
        dashboard: action.payload,
        isLoading: false,
      };

    default:
      return state;
  }
};

export default lawCaseReducer;
